function alumnis_Reducer(state = [], action) {
    switch (action.type) {
        case 'ALUMNIS/SET':
            return action.alumnis;
        case 'ALUMNIS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default alumnis_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/alumnis.js